<template>
<header>
    お気に入り
    <div class="h-left">
        <a @click="
          $router.push({ name: 'profile' });
          setFooter(true);
        "><img src="~@/assets/images/icon02.svg" /></a>
    </div>
</header>
<basic-dialog :active="isSendMessageLike">
    <div class="content-send-like-message">
        <p>メッセージを送りましょう！</p>
        <textarea @keypress="updateNumberMessage" v-model="contentMessageLike" placeholder="お相手の共通点や気になったことを伝えてみましょう！※メッセージ付いいね！ではポイントが消費されます。※メールアドレスLINE ID・カカオID Facebookのアカウントやその他SNSのID、電話番号などあなたできる個人情報は送信できません。"></textarea>
        <p class="error">{{ validMessage }}</p>
        <p class="note">あと{{ numberStringMessage }}文字</p>
        <div class="iine-btn1 submit" @click="submitSendMessageLike">
            <i class="fas fa-comment-dots"></i>メッセージ＆いいねする
        </div>
        <div class="iine-btn2 cancel" @click="closeSendMessageLike">
            キャンセル
        </div>
    </div>
</basic-dialog>
<div id="wrap2">
    <div v-for="(date, index) in dateTL" :key="index">
        <p style="font-size: 12px; margin-left: 2%">{{ date }}</p>
        <div class="list" v-for="(item, i) in arrayDate[date]" :key="i">
            <div class="clearfix">
                <div class="list-img">
                    <a @click="$router.push({ name: 'userDetail', query: { id: item.id } })"><img :src="getImageUrl(item.avatar_url)" /></a>
                </div>
                <div class="list-inf">
                    <table>
                        <tr>
                            <td>
                                <p>
                                    <span class="list-name">{{ getFieldProfile("living_area", item.living_area) }} {{ item.displayname }} {{ item.total_age }}歳</span>
                                </p>
                            </td>
                            <td rowspan="2" style="text-align: end; width: 64px">
                                {{ item.created_at }}
                            </td>
                        </tr>
                        <tr>
                            <td class="ellipsis">
                                <span v-if="parseInt(item.sex) === MALE" class="pink"> {{ getFieldProfile('income', item.income) }}&nbsp;</span>
                                <span>
                                    <span class="pink icon">
                                        <i class="fas fa-phone" v-if="parseInt(item.enabled_call) === IS_CALL"></i>
                                        通話OK&nbsp;
                                    </span>
                                    <span class="pink2 icon">
                                        <i class="fas fa-calendar-check" v-if="parseInt(item.is_free) === IS_WAITING_FOR_MEET"></i>
                                        本日OK
                                    </span>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="ellipsis" colspan="2">
                                {{ item.mood_status }}
                            </td>
                        </tr>
                        <tr v-if="parseInt(item.is_like_back) !== IS_LIKE_BACK">
                            <td colspan="2">
                                <div style="display: flex;">
                                    <div style="flex: 1; margin-right: 8px">
                                        <div class="iine-btn1" v-if="parseInt(item.is_like) !== IS_LIKE">
                                            <a @click="like(item.id, item.is_like, date, i)"><i class="fas fa-heart"></i> いいね</a>
                                        </div>
                                        <div :class="
                                parseInt(item.look_at_me_status) === IS_LOOK_AT_ME || parseInt(item.first_message_status) === FIRST_MESSAGE_STATUS_APPROVING
                                ? 'iine-btn2'
                                : 'iine-btn1'
                            " v-if="parseInt(item.is_like) === IS_LIKE">
                                            <a @click="lookAtMe(item.id, item.look_at_me_status, date, i)">みてね！する</a>
                                        </div>
                                    </div>
                                    <div style="flex: 2">
                                        <div :class="
                                parseInt(item.look_at_me_status) === IS_LOOK_AT_ME || parseInt(item.first_message_status) === FIRST_MESSAGE_STATUS_APPROVING
                                ? 'iine-btn2'
                                : 'iine-btn1'
                            ">
                                            <a @click="
                                opendSendMessageLike(item.id, parseInt(item.look_at_me_status), parseInt(item.first_message_status))
                                "><i class="fas fa-comment-dots"></i> メッセージ＆いいね</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-else>
                            <td colspan="2">
                                <div class="iine-btn1">
                                    <a @click="redirectChat(item)">メッセージを送る</a>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<infinite-loading @infinite="getFavoriteList" style="height: 100%" spinner="spiral">
    <template v-slot:no-more></template>
    <template v-slot:no-results>
        <div id ="middle" style="width:100%">
            お気に入りリストはありません。
        </div>
    </template>
</infinite-loading>
<!-- Subscription -->
<subscriptionAlert :active="isShowAlertSubscription">
    <div class="subscription">
        <div class="title">有料会員の登録が必要です</div>
        <div class="content">簡単ステップで<br>有料会員の登録を済ませましょう</div>
        <div class="btn1" @click="openSubscription()">詳しく見る</div>
    </div>
</subscriptionAlert>
<!-- Verify age -->
<subscriptionAlert :active="isShowAlertVerifyAge">
    <div class="subscription">
        <div class="title">年齢認証が必要です</div>
        <div class="content">
            <h3>簡単ステップで<br>年齢確認を済ませましょう。</h3>
            <br>
            お相手とのメッセージを行うためには<br>法令により年齢確認が必要となります。
        </div>
        <div class="btn1" @click="openVerifyAge()">詳しく見る</div>
    </div>
</subscriptionAlert>
<div id="subscription" class="hidden-right">
    <subscription :isShow="true" @close="closeSubscription"></subscription>
</div>
<div id="very-age" class="hidden-right">
    <veryAge :isShow="true" @close="closeVerifyAge"></veryAge>
</div>
<successDialog :active="isShowAlertProcessApprove" @close="isShowAlertProcessApprove = false">
    <template v-slot:message>
        <h3>現在年齢認証中です。</h3>
        <p>最大24時間かかります。</p>
    </template>
</successDialog>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import CONSTANTS from "@/constants";
import mixin from "@/mixin";
import BasicDialog from "./components/basicDialog.vue";
import subscriptionAlert from '../user/components/subscriptionAlert.vue'
import subscription from './subscription'
import veryAge from './veryAge.vue'
import successDialog from '@/views/components/successDialog'
export default {
    components: {
        BasicDialog,
        subscriptionAlert,
        subscription,
        veryAge,
        successDialog,
    },
    data: () => ({
        pageSize: 10,
        pageCurrent: 1,
        favoriteList: [],
        IS_LIKE: CONSTANTS.IS_LIKE,
        IS_LIKE_BACK: CONSTANTS.IS_LIKE_BACK,
        IS_LOOK_AT_ME: CONSTANTS.IS_LOOK_AT_ME,
        isSendMessageLike: false,
        contentMessageLike: null,
        validMessage: null,
        isValid: false,
        numberStringMessage: 200,
        userId: null,
        FIRST_MESSAGE_STATUS_APPROVING: CONSTANTS.FIRST_MESSAGE_STATUS_APPROVING,
        isShowAlertSubscription: false,
        isShowAlertVerifyAge: false,
        isShowAlertProcessApprove: false,
        arrayDate: [],
        dateTL: [],
        MALE: CONSTANTS.MALE,
        IS_WAITING_FOR_MEET: CONSTANTS.IS_WAITING_FOR_MEET,
        IS_CALL: CONSTANTS.IS_CALL,
    }),
    mixins: [mixin],
    mounted() {
        this.setFooter(false)
        this.getTemplateMessage()
        this.clickOutside()

    },
    computed: {
        ...mapGetters(["defaultToken", "metadata", "userDetail"]),
    },
    methods: {
        ...mapActions({
            getDefaultToken: "user/getDefaultToken",
            setFooter: "layout/setFooter",
            getNotices: "profile/getNotices",
            likeUser: "user/likeUser",
        }),
        closeSubscription() {
            document.getElementById('subscription').classList.remove('show-right')
            document.getElementById('subscription').classList.add('hidden-right')
        },
        openSubscription() {
            this.isShowAlertSubscription = false
            document.getElementById('subscription').classList.add('show-right')
            document.getElementById('subscription').classList.remove('hidden-right')
        },
        openVerifyAge() {
            this.isShowAlertVerifyAge = false
            document.getElementById('very-age').classList.add('show-right')
            document.getElementById('very-age').classList.remove('hidden-right')
        },
        closeVerifyAge(val) {
            if (val) {
                this.userDetail.is_verify_age = CONSTANTS.PC_VERY_AGE
            }
            document.getElementById('very-age').classList.remove('show-right')
            document.getElementById('very-age').classList.add('hidden-right')
        },
        async getFavoriteList($state = null) {
            if (this.favoriteList.length > 0 && this.favoriteList.length < this.pageSize && $state) {
                $state.complete();
                return;
            }
            let params = {
                page: this.pageCurrent,
                limit: this.pageSize,
                token: this.defaultToken,
            };
            await this.$store
                .dispatch("profile/getFavoriteList", params)
                .then((data) => {
                    if (data.result[0]) {
                        this.favoriteList.push(...data.result);
                        this.pageCurrent++;
                        this.favoriteList = this.favoriteList.sort((a, b) => {
                        if (new Date(a.send_date_time) > new Date(b.send_date_time)) return -1;
                        if (new Date(a.send_date_time) < new Date(b.send_date_time)) return 1;
                        return 0;
                        });
                        this.dateTL = this.favoriteList.map((item) => {
                        return this.formatDateTime(item.send_date_time);
                        });
                        this.dateTL = Array.from(new Set(this.dateTL));
                        for (let i = 0; i < this.dateTL.length; i++) {
                            let arr = this.favoriteList.filter((e) => {
                                return this.formatDateTime(e.send_date_time) == this.dateTL[i];
                            });
                            if (arr.length > 0) {
                                this.arrayDate[this.dateTL[i]] = arr;
                            }
                        }
                        this.dateTL.filter((item) => {
                        if (this.arrayDate[item]) {
                            return true;
                        }
                        return false;
                        });
                        if ($state) {
                            $state.loaded();
                        }
                    } else {
                        if ($state) {
                            $state.complete();
                        }
                    }
                })
                .catch((err) => {
                    if ($state) {
                        $state.complete();
                    }
                });
        },
        getFieldProfile(field, id) {
            if (!this.metadata || !this.metadata.user_profile_list) return null;
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        like(id, isLike, date, i) {
            if (parseInt(isLike) !== CONSTANTS.IS_LIKE) {
                let formData = new FormData();
                formData.append("type", 0);
                formData.append("token", this.defaultToken);
                formData.append("user_like_id", id);
                this.likeUser(formData)
                    .then(() => {
                        this.likeStatus = true
                        this.pageCurrent = 1
                        // this.favoriteList = []
                        this.arrayDate[date][i].is_like = CONSTANTS.IS_LIKE
                        // this.getFavoriteList()
                    })
                    .catch((err) => {
                        console.log(err);
                        if (err.message === CONSTANTS.NO_POINT) {
                            this.$router.push({
                                name: "buyPoint"
                            });
                        }
                    });
            }
        },
        lookAtMe(id, lookAt, date, i) {
            if (parseInt(lookAt) !== CONSTANTS.IS_LOOK_AT_ME) {
                let formData = new FormData();
                formData.append("token", this.defaultToken);
                formData.append("user_look_at_id", id);
                formData.append("message", CONSTANTS.MESSAGE_LOOK_AT_ME);
                this.$store
                    .dispatch("like/lookAtMe", formData)
                    .then((data) => {
                        this.pageCurrent = 1
                        // this.favoriteList = []
                        this.arrayDate[date][i].look_at_me_status = CONSTANTS.IS_LOOK_AT_ME
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        opendSendMessageLike(userId, lookAt, first_message_status) {
            if (lookAt !== CONSTANTS.IS_LOOK_AT_ME && first_message_status !== this.FIRST_MESSAGE_STATUS_APPROVING) {
                if (parseInt(this.userDetail.is_subscription) !== CONSTANTS.IS_SUBSCRIPTION && parseInt(this.userDetail.sex) === CONSTANTS.MALE) {
                    this.isShowAlertSubscription = true
                    return
                }
                if (parseInt(this.userDetail.is_verify_age) === CONSTANTS.NO_VERY_AGE) {
                    this.isShowAlertVerifyAge = true
                    return
                }
                if (parseInt(this.userDetail.is_verify_age) === CONSTANTS.PC_VERY_AGE) {
                    this.isShowAlertProcessApprove = true
                    return
                }
                this.isSendMessageLike = true
                this.userId = userId
            }
        },
        submitSendMessageLike() {
            if (this.contentMessageLike.length < 10) {
                this.isValid = true
                this.validMessage = "10文字以上を入カしてください"
            } else {
                let formData = new FormData()
                formData.append("token", this.defaultToken)
                formData.append("type", 0)
                formData.append("user_like_id", this.userId)
                formData.append("message", this.contentMessageLike)
                this.$store
                    .dispatch("profile/sendLikeMessage", formData)
                    .then((data) => {
                        this.pageCurrent = 1
                        this.getFavoriteList()
                        this.favoriteList = []
                        this.closeSendMessageLike()
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        updateNumberMessage() {
            this.numberStringMessage--;
            if (this.numberStringMessage === 0) {
                document.querySelector("textarea").setAttribute("disabled", true);
            }
        },
        closeSendMessageLike() {
            this.isSendMessageLike = false;
            this.numberStringMessage = 200;
            document.querySelector("textarea").setAttribute("disabled", false);
            this.isValid = false;
            this.validMessage = null;
            this.contentMessageLike = null;
        },
        getTemplateMessage() {
            this.$store
                .dispatch("message/getMessageTemplate", {
                    token: this.defaultToken,
                })
                .then((data) => {
                    if (data[0]) {
                        this.contentMessageLike = data[0].body;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        redirectChat(item) {
            if (parseInt(this.userDetail.is_subscription) !== CONSTANTS.IS_SUBSCRIPTION && parseInt(this.userDetail.sex) === CONSTANTS.MALE) {
                this.isShowAlertSubscription = true
                return
            }
            if (parseInt(this.userDetail.is_verify_age) === CONSTANTS.NO_VERY_AGE) {
                this.isShowAlertVerifyAge = true
                return
            }
            if (parseInt(this.userDetail.is_verify_age) === CONSTANTS.PC_VERY_AGE) {
                this.isShowAlertProcessApprove = true
                return
            }
            this.$router.push({
                name: "chat",
                query: {
                    user_id: item.id,
                    user_code: item.user_code
                },
            });
        },
        clickOutside() {
            document.addEventListener("click", (evt) => {
                const flyoutElement = document.getElementById("subscription");
                let targetElement = evt.target; // clicked element
                do {
                    if (targetElement == flyoutElement) {
                        return;
                    }
                    // Go up the DOM
                    targetElement = targetElement.parentNode;
                    // targetElement.getElementsByTagName('img')[0].src = document.getElementById('main_avatar').getElementsByTagName('img')[0].src;
                } while (targetElement);
                const wrap = document.querySelector(".wrap");
                if (wrap == evt.target) {
                    this.isShowAlertSubscription = false
                    this.isShowAlertVerifyAge = false
                }
                // This is a click outside.

            });
        }
    },
};
</script>

<style scoped>
.iine-btn2 {
    font-size: 12px;
}

.content-send-like-message {
    background: #ffff;
    padding: 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.content-send-like-message textarea {
    width: 99%;
    height: 150px;
    margin-top: 15px;
}

.content-send-like-message div {
    margin: 5px;
    padding: 2px;
    color: #fff;
}

.content-send-like-message div.cancel {
    width: 50%;
}

.content-send-like-message div.submit {
    width: 80%;
}

.content-send-like-message p {
    margin: 5px;
}

.content-send-like-message .error {
    height: 10px;
    color: red;
    font-size: 10px;
    text-align: left;
    width: 100%;
}

.content-send-like-message p.note {
    width: 100%;
    text-align: right;
    background: none;
    padding: 0px;
    font-size: 10px;
}
.subscription {
    background: #fff;
    padding-bottom: 10px;
}
.subscription .content {
    padding: 20px;
}
.subscription .btn1 {
    color: #fff;
    padding: 10px;
}
.hidden-right {
    position: fixed;
    right: -100%;
    top: 0;
    width: 100%;
    overflow: hidden;
}
.show-right {
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    overflow: hidden;
    z-index: 999999;
    background: #fff;
    overflow: scroll;
    height: 100vh;
}
#subscription, #very-age {
    transition: all 0.2s;
}
.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.pink {
    font-size: 11px;
}

.pink.icon,
.pink2.icon {
    font-size: 10px;
}
</style>
